/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminParentGetParentsFromOrganizationParams,
  OrganizationUserAdminDTOQueryResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminParentGetParentsFromOrganization = (
    organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminParent`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminParentGetParentsFromOrganizationQueryKey = (organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminParent`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminParentGetParentsFromOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminParentGetParentsFromOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>> = ({ signal }) => adminParentGetParentsFromOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminParentGetParentsFromOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>>
export type AdminParentGetParentsFromOrganizationQueryError = ErrorType<unknown>


export function useAdminParentGetParentsFromOrganization<TData = Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminParentGetParentsFromOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminParentGetParentsFromOrganization<TData = Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminParentGetParentsFromOrganization<TData = Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminParentGetParentsFromOrganization<TData = Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminParentGetParentsFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminParentGetParentsFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminParentGetParentsFromOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



